/* eslint-disable */
import React, { Component } from 'react'
import { SafeAreaView, ScrollView, Text, View, StatusBar, TouchableWithoutFeedback, Keyboard } from 'react-native'
import { connect } from 'react-redux'
//import SpinnerScreen from "./SpinnerScreen";
import styles from './Styles/BaseScreenStyle'
//import KeyboardComponent from '../Components/KeyboardComponent'
import EventEmitter from 'EventEmitter'
import { showError } from '../Lib/utils'
import { Fonts } from '../Themes'
import UserActions from "../Redux/UserRedux"

const CustomStatusBar = ({ backgroundColor, ...props }) => (
  <View style={[styles.statusBar, { backgroundColor }]}>
    <StatusBar translucent backgroundColor={backgroundColor} {...props} />
  </View>
);
class BaseScreen extends Component {
  constructor(props) {
    super(props);
    this.emitter = new EventEmitter()
    this.props.refreshAvatar() // force avatar pull once per session
  }

  render() {
    const {

      children,
      keyboardAccessory,
      showKeyboardAccessory,
      fullLoading = false,
      darkStatusbar = false,
      style
    } = this.props
    return (
      // <SafeAreaView style={{ flex: 1, backgroundColor: Fonts.style.color.background }}>
      <View style={[styles.container,style]}>
        {darkStatusbar && (<CustomStatusBar backgroundColor="white" barStyle="dark-content" />)}
        {children}
        {keyboardAccessory && (
          <View
            emitter={this.emitter}
            visible={showKeyboardAccessory}>
            {keyboardAccessory}
          </View>
        )}
        {this.props.fullLoading && (
          <View style={styles.loader}>
            <View size="medium" type="light" />
          </View>
        )}

      </View>
      // </SafeAreaView>

    )
  }
}

const mapStateToProps = (state) => {
  return {
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
      refreshAvatar: ( ) => dispatch(UserActions.refreshAvatar( )),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BaseScreen)
